import { CommissionsPayload, CommissionsResponse } from 'services/api/common-types/types-commissions';

import { post } from '../base';

export function getPosCommissions(params: CommissionsPayload): Promise<CommissionsResponse> {
  return post('v3/commissions', { json: params }).json();
}
